/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-Grid{margin:0 -8px}.ms-Panel{z-index:600}"}]);